import { render, staticRenderFns } from "./NewCredentialsCard.vue?vue&type=template&id=fa9eced6&scoped=true&"
import script from "./NewCredentialsCard.vue?vue&type=script&lang=js&"
export * from "./NewCredentialsCard.vue?vue&type=script&lang=js&"
import style0 from "./NewCredentialsCard.vue?vue&type=style&index=0&id=fa9eced6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9eced6",
  null
  
)

export default component.exports